import { typedQueryClient, useTypedMutation } from "hooks";
import { updateQuestionResultPinHistory } from "modules/AppointmentDetails/components/Checks/components/Check/components/QuestionResults/utils";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Pin, QuestionResult } from "models";
import type { AppendPinResponse } from "modules/AppointmentDetails/components/Interventions/hooks";

const updatePinHistory = (questionResult: QuestionResult, pin: Pin) => {
  const pinHistory = questionResult.pin_history ?? [];
  const pinIdx = pinHistory.findIndex(p => p.id === pin.id);

  return pinIdx < 0 ? [...pinHistory, pin] : pinHistory.with(pinIdx, { ...pinHistory[pinIdx], ...pin });
};

export const usePinQuestionResultMutation = () =>
  useTypedMutation<Pin, AppendPinResponse>({
    mutationFn: async payload => (await ApiInstance.post("/pins/append", payload)).data,
    onSuccess: (payload, { pin_id }) => {
      const checks = typedQueryClient.getQueryData(AppointmentDetailsKeys.checks);
      if (!checks?.length || !payload.question_result_id) return;

      updateQuestionResultPinHistory({
        checks,
        question_result_id: payload.question_result_id,
        updatePinHistory: questionResult => updatePinHistory(questionResult, { ...payload, id: pin_id })
      });
    }
  });
